import { jsx } from "panel";
import { WarningEl } from "common/components/warning";
export function template() {
  const {
    print
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".warning-hero-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(WarningEl, { attrs: {
    "cta-href": this.attr("cta-href"),
    "cta-text": print(this.params.ctaText),
    "header-text": print(this.params.headerText),
    theme: this.helpers.getTheme(),
    "img-src": this.helpers.getImgSrc(),
    "body-text": this.helpers.getBodyText()
  }, on: {
    ctaClick: this.helpers.handleCtaClick
  }, "data-sentry-element": "WarningEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" })));
}
